import styled from '@emotion/styled';
import { H2, SmallText, Text } from 'ds/components/typography';
import { SpacingScale } from 'ds/theme/spacing';
import { Link } from 'ds/components/link';


export const Wrapper = styled.div<{ spacing?: SpacingScale; isPrimary: boolean }>(({ theme, spacing, isPrimary }) => ({
  backgroundColor: theme.colors.neutrals.white,
  borderRadius: theme.borderRadius.large,
  border: `1px solid ${theme.colors.neutrals.grey8}`,
  boxShadow: isPrimary ? theme.shadow.level7 : 'none',
  padding: theme.spacing(spacing || 3),
  display: 'flex',
  flexDirection: 'column',
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    height: '100%',
  },
  paddingBottom: theme.spacing(2),
  maxWidth: isPrimary ? 'auto' : 276,
  height: '100%',
  position: 'relative',
}));

export const StarWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const Title = styled.div<{ cropTitle?: boolean }>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ cropTitle }) => cropTitle ? 'white-space: nowrap;' : ''};
  flex-shrink: 0;
`;

export const Subtitle = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  flex-shrink: 0;
`;

export const Insights = styled(Text)`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: auto;
`;

export const Info = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(2, 0, 0),
  borderTop: `1px dashed ${theme.colors.neutrals.grey6}`,
  display: 'flex',
  justifyContent: 'space-between',
}));

export const InfoCol = styled.div``;

export const InfoTitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const InfoValue = styled(H2.withComponent('div'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const LinkWrapper = styled(Text)(({ theme }) => ({
  borderTop: `1px dashed ${theme.colors.neutrals.grey6}`,
  marginTop: theme.spacing(3),
  paddingTop: theme.spacing(2),
  '& > a': {
    textDecoration: 'none',
  },
}));

export const StyledLink = styled(Link)(() => ({
  cursor: 'pointer',
}));

export const NeighborhoodInsightChips = styled.div(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  alignItems: 'flex-start',
}));
